import { ApiProperty } from "@nestjs/swagger";
import { PoBomItem } from "./po-bom-item.dto";

export class PoBomInfo {
    bomItems: PoBomItem[];
}